import urls from "./util/urls"
import service from "./config/service" 
import {cacheTemplate} from './util/options';
import cache from "./config/cache";
import defaultsDeep from 'lodash.defaultsdeep';

export default (options, next) => {
    getMenuInfo(options, next);
}

function getMenuInfo (options, next) {

    service(urls.getMenuInfo, {params: {
        code: getUrlParam("code")
    }}).then((res)=>{
        if (!res) return;
        cache.setObject({
            'x-position-code': res.positionCode,
            'x-dealer-code': res.dealerCode,
            'x-user-code': res.userCode,
            'x-user-name': res.userName,
            'x-pagesession-code': res.pageSessionId,
            'currentPositionInfo': res.currentPositionInfo,
            'x-store-code': res.storeCode,
            'x-sale-code': res.saleCode,
            'x-service-code': res.serviceCode,
            'x-org-code': res.orgCode,
            'userInfo': res.userInfo,
            'htmlContent': res.htmlContent
        }, cacheTemplate);

        // resource, menu
        getResourceData(options, next)

    })
}

/**
 * get resource, menu 
 */
function getResourceData (options, next) {
    service(urls.RESOURCEINFO, {}).then((res)=>{
        if (!res) return;
        if (res.message === 'success') {
            cache.setObject({
                "menu": cache.get('isDmsEnd') ? processMenu(res.data.menuMap) : processMenu(res.data.menu),
                "resouces": defaultsDeep(resoucesProcess(res.data.resouces), cache.resouces),
                "resoucesIds": res.data.resouces,
                "requireAuth": true
            }, cacheTemplate);

            if (options.callback) {
                options.callback(next);
            }
            else {
                next();
            }
        }
    })
}

function processMenu (data) {
    let arr = [];
    for(let k in data) {
        if (/_/.test(k)) {
            let a = k.split('_');
            arr[a[0]]['children'][a[1]] = data[k];
        }
        else {
            arr[k] = data[k];
            arr[k]['children'] = [];
        }
    }
    return arr.filter(d=>{
        let t = d.children.filter(b=>b);
        d.children = t;
        return d;
    });
}

function getUrlParam(key) {
    let str = window.location.search;
    let objURL = {};

    str.replace(
      new RegExp( "([^?=&]+)(=([^&]*))?", "g" ),
      ( $0, $1, $2, $3 ) => {
        objURL[ $1 ] = $3;
      }
    );

    return objURL.key;
}



function resoucesProcess (data) {

    if (!data) return;
    let ob = {};
    for(let k in data) {
        ob[data[k]['method']+','+data[k]['path']]= data[k];
    }
    return ob;
}